"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formControl = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

var formControl = {
  colors: {
    default: {
      color: _colors.colors.gray700,
      background: _colors.colors.white,
      border: _colors.colors.gray400,
      borderFocus: _colors.colors.formControlBorderFocus,
      boxShadowFocus: _colors.colors.formControlBoxShadowFocus,
      placeholder: _colors.colors.gray,
      backgroundColorDisabledReadonly: _colors.colors.gray200,
      borderValid: _colors.colors.green,
      formControlBoxShadowValid: _colors.colors.formControlBoxShadowValid,
      borderInvalid: _colors.colors.red,
      formControlBoxShadowInvalid: _colors.colors.formControlBoxShadowInvalid
    }
  },
  borderRadius: _utils.utils.borderRadius,
  border: _utils.utils.border,
  boxShadow: {
    default: '0 0 0 0.2rem'
  },
  padding: {
    smRight: '0',
    smLeft: '0',
    lgRight: '0',
    lgLeft: '0',
    smPadding: '0.25rem 0.5rem',
    lgPadding: '0.5rem 1rem',
    defaultPadding: '0.375rem 0.75rem'
  },
  fontSize: {
    sm: '0.875rem',
    lg: '1.25rem',
    default: '1rem'
  },
  height: {
    select: 'calc(2.25rem + 2px)',
    selectLg: 'calc(2.875rem + 2px)',
    selectSm: 'calc(1.8125rem + 2px)'
  }
};
exports.formControl = formControl;